import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Cad from '../../assets/images/cad.png';
import { FilePdfOutlined } from '@ant-design/icons';
import './styles.css';

interface IProps {
    thumbnail: string | null | undefined;
    has_file_3d: boolean;
    width?: string;
    maxHeight?: string;
}

export const PartPreview = (props: IProps) => {
  const { thumbnail, width, maxHeight } = props;

  return (
    <div style={{ width: width ?? '120px', maxHeight: maxHeight }}>
      {thumbnail ? (
        <img
          className="thumbnail-3d-file ml-auto mr-auto"
          alt="Part Thumbnail"
          src={thumbnail}
          style={maxHeight ? { maxHeight, objectFit: 'contain' } : undefined}
        />
      ) : (
        <div className="flex justify-center m-auto w-full">
          <FilePdfOutlined className="iconPreview" />
        </div>
      )}
    </div>
  );
};
